<template>
  <v-container class="pa-0 fill-height d-flex flex-column">
    <v-alert
      class="mt-2"
      v-if="this.displayDebugNotification"
      @input="closeAlert()"
      color="red"
      dismissible
      elevation="2"
      type="info">
      {{ debugNotification }}
    </v-alert>
    <v-container
      class="blue-background flex-grow-1 overflow-auto"
      style="height: 0">
      <slot></slot>
    </v-container>
    <v-container class="flex-shrink-0 flex-grow-0">
      <HfrButton
        v-show="enableNext"
        :disabled="false /*!formIsValid*/"
        @click="toggleNavigateToNextStep()"
        type="primary">
        {{ $t('global.next') }}
      </HfrButton>
      <HfrButton v-show="enableBack" @click="doPreviousStep()" class="mt-2">
        {{ $t('global.back') }}
      </HfrButton>
    </v-container>
  </v-container>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import HfrButton from './HfrButton.vue';

export default {
  components: { HfrButton },
  props: {
    enableBack: { type: Boolean, default: true },
    enableNext: { type: Boolean, default: true }
  },
  methods: {
    ...mapActions('navigation', ['toggleNavigateToNextStep', 'doPreviousStep']),
    ...mapActions('notification', ['closeDebugNotification']),
    closeAlert() {
      this.closeDebugNotification();
    }
  },
  computed: {
    ...mapState('navigation', ['formIsValid']),
    ...mapState('notification', [
      'displayDebugNotification',
      'debugNotification'
    ])
  }
};
</script>
<style lang="scss">
.step-title {
  size: 17px;
  color: #243876;
  font-weight: bold;
}

.field-warning {
  color: red;
  size: 12px;
}

.theme--light.v-text-field--filled > .v-input__control > .v-input__slot {
  background-color: #f7f9fd;
}
</style>
